import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { orderReducer } from './order';

const rootReducer = combineReducers({
   order: orderReducer
})

export const store = configureStore({
   reducer: rootReducer,
})